import { useRef } from 'react';

import {
  AppBar,
  AppBarProps,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Avatar,
  Icon,
} from '@material-ui/core';

import logo from 'assets/images/logo16.svg';
import { useAuth, useBootstrapApp } from 'hooks';

import { useStyles } from './styles';

export function Header(props: AppBarProps): JSX.Element {
  const anchorRef2 = useRef<HTMLButtonElement>(null);
  const { user } = useAuth();
  const { indicatorEvent } = useBootstrapApp();

  const {
    appheaderStyle,
    btnHeaderStyle,
    headerStyle,
    examTitleStyle,
    logoStyle,
    titleStyle,
    toolbarStyle,
  } = useStyles();

  return (
    <div className={appheaderStyle}>
      <AppBar className={headerStyle} position="relative" {...props}>
        <Toolbar className={toolbarStyle}>
          <IconButton aria-label="logo">
            <Avatar className={logoStyle} alt="Logo" src={logo} />
          </IconButton>
          <Typography className={titleStyle}>
            SOMOS Avaliação |{' '}
            <span className={examTitleStyle}>{indicatorEvent?.name}</span>
          </Typography>
          <Button
            ref={anchorRef2}
            className={btnHeaderStyle}
            startIcon={<Icon>person</Icon>}
            color="inherit"
          >
            {user?.name || 'Área do Usuário'}
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}
